var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#696969",
    d: "M40 5C59.329967 5 75 20.670034 75 40C75 59.329967 59.329967 75 40 75C20.670034 75 5 59.329967 5 40C5 20.670034 20.670034 5 40 5ZM40 80C62.091389 80 80 62.091389 80 40C80 17.908609 62.091389 0 40 0C17.908609 0 0 17.908609 0 40C0 62.091389 17.908609 80 40 80ZM56.765625 31.765625C57.734375 30.796875 57.734375 29.203125 56.765625 28.234375C55.796875 27.265625 54.203125 27.265625 53.234375 28.234375L35 46.46875L26.765625 38.234375C25.796875 37.265625 24.203125 37.265625 23.234375 38.234375C22.265625 39.203125 22.265625 40.796875 23.234375 41.765625L33.234375 51.765625C34.203125 52.734375 35.796875 52.734375 36.765625 51.765625L56.765625 31.765625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.5ba12541f3aa4c866d086c21e6aeb550.svg";
export { ForwardRef as ReactComponent };